import React from 'react';
import '../styles/App.css';

const SessionExpiredModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content session-expired-modal">
        <h3>登录已过期</h3>
        <p>您的登录状态已失效，请重新登录以继续操作。</p>
        <div className="modal-actions">
          <button className="btn-primary" onClick={onClose}>
            重新登录
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
